import { api } from './api';

export interface ManagedUser {
  id: number;
  tenantId: number;
  warehouseId: number | null;
  warehouse: {
    id: number;
    name: string;
    status: string;
  } | null;
  tenant: {
    id: number;
    name: string;
    status: string;
  } | null;
  email: string;
  roleId: number;
  role: {
    id: number;
    name: string;
    description?: string | null;
    permissions: string[];
  } | null;
  permissions: string[];
  name: string | null;
  phone: string | null;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface UserListResponse {
  items: ManagedUser[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface UserFilters {
  search?: string;
  roleId?: number;
  page?: number;
  limit?: number;
  sort?: 'createdAt' | 'email' | 'name' | 'status';
  order?: 'ASC' | 'DESC';
}

export interface CreateManagedUserPayload {
  email: string;
  password?: string;
  warehouseId: number;
  roleId?: number;
  name: string;
  phone: string;
  status?: string;
}

export interface UpdateManagedUserPayload {
  warehouseId?: number;
  roleId?: number;
  name?: string;
  phone?: string;
  status?: string;
}

export const userManagementService = {
  getUsers: async (filters?: UserFilters): Promise<UserListResponse> => {
    const params = new URLSearchParams();

    if (filters?.search) params.append('search', filters.search);
    if (filters?.roleId) params.append('roleId', String(filters.roleId));
    if (filters?.page) params.append('page', String(filters.page));
    if (filters?.limit) params.append('limit', String(filters.limit));
    if (filters?.sort) params.append('sort', filters.sort);
    if (filters?.order) params.append('order', filters.order);

    const response = await api.get<UserListResponse>(`/users?${params}`);
    return response.data;
  },

  createUser: async (payload: CreateManagedUserPayload): Promise<ManagedUser> => {
    const response = await api.post<ManagedUser>('/users', payload);
    return response.data;
  },

  updateUser: async (
    userId: number,
    payload: UpdateManagedUserPayload,
  ): Promise<ManagedUser> => {
    console.log('📤 Sending update request:', { userId, payload });
    const response = await api.patch<{ message: string; data: ManagedUser }>(`/users/${userId}`, payload);
    console.log('📥 Update response full:', response);
    console.log('📥 Update response data:', (response as any).data);
    return (response as any).data;
  },

  getUserById: async (userId: number): Promise<ManagedUser> => {
    const response = await api.get<ManagedUser>(`/users/${userId}/basic-info`);
    return response.data;
  },
};
